import { render, staticRenderFns } from "./MojeLige.vue?vue&type=template&id=64f29502&scoped=true&"
import script from "./MojeLige.vue?vue&type=script&lang=js&"
export * from "./MojeLige.vue?vue&type=script&lang=js&"
import style0 from "./MojeLige.vue?vue&type=style&index=0&id=64f29502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f29502",
  null
  
)

export default component.exports